import {Directive, HostListener, Input, Optional} from '@angular/core';

import {DialogRef} from '../shared/ui-kits/dialog/dialog-ref';

/**
 * Button that will close the current dialog
 */
@Directive({
  selector: '[DialogClose]',
})
export class DialogCloseDirective<T = any> {
  @Input('DialogClose') dialogResult!: T;

  constructor(@Optional() private dialogRef: DialogRef) {}

  @HostListener('click') onClick(): void {
    if (!this.dialogRef) {
      return;
    }

    this.dialogRef.close(this.dialogResult);
  }
}
